<div class="app-auth-params-container">
  <div class="app-auth-params">
    @for (field of field.fieldGroup; track field.id; let index = $index; let first = $first; let length = $count) {
      <div class="app-auth-param">
        <div class="app-auth-param-inputs">
          <formly-field [field]="field" />
        </div>
        <div class="app-auth-param-action">
          <cap-button
            styleClass="secondary round btn-sm"
            icon="mynaui-trash"
            [label]="'button.delete' | translate"
            (onClick)="remove(index)" />

          <cap-button
            styleClass="primary round btn-sm"
            icon="mynaui-check"
            [label]="'button.save' | translate"
            (onClick)="save(index)" />
        </div>
      </div>
    }
  </div>

  @if (!isAddingParam() && field.fieldGroup.length < 2) {
    <div class="app-auth-params-action">
      <cap-button styleClass="primary" icon="mynaui-plus" [label]="'button.add' | translate" (onClick)="add()" />
    </div>
  }
</div>
